import React, { PropsWithChildren, useState } from 'react';
import { Box, Drawer, useMediaQuery } from '@mui/material';
import Sidebar from '../components/Sidebar/Sidebar';
import TopBar from '../components/TopBar/TopBar';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import VerificationSystemSidebar from '@/components/Sidebar/verificationSystemSidebar';

const IndigentLayout: React.FC<PropsWithChildren> = ({ children }) => {
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const [mobileOpen, setMobileOpen] = useState(false);

    // Check if current route is HomePage (root path)
    const isHomePage = location.pathname === '/';

    const isVerificationSystem = location.pathname.startsWith('/verification');
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Pass toggle function to TopBar */}
            <TopBar onDrawerToggle={handleDrawerToggle} />

            <Box display='flex' sx={{ flex: 1, minHeight: 0 }}>
                {/* Desktop Sidebar - Hide for HomePage */}
                {!isMobile && !isHomePage && (
                    <Box
                        sx={{
                            width: '230px',
                            borderRight: '1px solid #eee',
                            boxShadow: '2px 0 5px rgba(0,0,0,0.05)',
                            backgroundColor: '#fff',
                        }}
                    >
                        {isVerificationSystem ? (
                            <VerificationSystemSidebar
                                isMobile={isMobile}
                                isOpen={isMobile ? mobileOpen : true}
                                onClose={handleDrawerToggle}
                            />
                        ) : (
                            <Sidebar
                                isMobile={isMobile}
                                isOpen={isMobile ? mobileOpen : true}
                                onClose={handleDrawerToggle}
                            />
                        )}
                    </Box>
                )}

                {/* Mobile Drawer Sidebar - Hide for HomePage */}
                {isMobile && !isHomePage && (
                    <Drawer
                        variant='temporary'
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        ModalProps={{
                            keepMounted: true, // Better mobile performance
                        }}
                        sx={{
                            '& .MuiDrawer-paper': {
                                width: '230px',
                                boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
                            },
                        }}
                    >
                        {isVerificationSystem ? (
                            <VerificationSystemSidebar
                                isMobile={isMobile}
                                isOpen={isMobile ? mobileOpen : true}
                                onClose={handleDrawerToggle}
                            />
                        ) : (
                            <Sidebar
                                isMobile={isMobile}
                                isOpen={isMobile ? mobileOpen : true}
                                onClose={handleDrawerToggle}
                            />
                        )}
                    </Drawer>
                )}

                <Box
                    key={location.pathname}
                    component='main'
                    sx={{
                        flex: 1,
                        backgroundColor: '#FEFBFF',
                        p: isHomePage ? 0 : 3, // Remove padding for HomePage
                        pt: isHomePage ? 0 : 12, // Remove top padding for HomePage
                        overflow: 'auto',
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
};

export default IndigentLayout;
